import { Component, OnInit } from '@angular/core';
import { BinanceApiService } from '../../_services/binancapi.service';;

@Component({
    selector: 'binance-api',
    templateUrl: './binance-api.component.html',
    styleUrls: ['./binance-api.component.css']
})

export class BinanceApiComponent implements OnInit {
    model: any = {};
    loading: boolean = false;
    message: string = '';
    success: boolean = false;
    constructor(private binanceApiService: BinanceApiService) { }

    ngOnInit() {
        this.binanceApiService.gets().subscribe(data => {
            if (data) {
                this.model.apiKey = data.api_key;
                this.model.secretKey = data.secret_key;
                this.model.amountBtc = data.amount_btc;
                this.model.amountEth = data.amount_eth;
                this.model.amountBnb = data.amount_bnb;
                this.model.amountUsdt = data.amount_usdt;
                this.model.stopLoss = data.stop_loss;
                this.model.rateOfUp = data.rate_of_up;
            }
        }, error => {
            this.message = error;
        });
    }

    save() {
        this.message = '';
        this.loading = true;
        this.binanceApiService.save(this.model).subscribe(data => {
            this.loading = false;
            if (data.error == true) {
                this.message = data.message;
                this.success = false;
            } else {
                this.message = '保存成功！';
                this.success = true;
            }
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/binance-api/binance-api.component.ts